import React, { useCallback, useEffect } from "react";
import PropTypes from "prop-types";
import EntitiesSelector, { commonPropTypes } from "./entities-selector";
import { injectIntl } from "react-intl";

export const ocurrencesSourceTypesQuery = `
  query OcurrencesSourceTypes($contractId: ID, $eventTypeId: String) {
    ocurrencesSourceTypes(contractId: $contractId, eventTypeId: $eventTypeId) {
      items
      total
    }
  }
`;

const OcurrencesSourceTypesSelect = ({
  intl,
  multiple = false,
  id = "ocurrencesSourceTypes",
  name = "ocurrencesSourceTypes",
  isInsideForm,
  ...props
}) => {
  const handleDataFromResponse = useCallback(data => data.ocurrencesSourceTypes, []);
  const handleGetValue = useCallback(element => element, []);
  const handleGetLabel = useCallback(element => element, []);

  return (
    <EntitiesSelector
      isInsideForm={isInsideForm}
      id={id}
      name={name}
      queryString={ocurrencesSourceTypesQuery}
      onGetDataFromResponse={handleDataFromResponse}
      onGetValue={handleGetValue}
      onGetLabel={handleGetLabel}
      {...props}
    />
  );
};

OcurrencesSourceTypesSelect.propTypes = {
  ...commonPropTypes,
  /**
   * Valor del selector
   */
  selectedElement: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  /**
   * Valor del selector
   */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
};

export default injectIntl(OcurrencesSourceTypesSelect);
